class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector('.not-pu-section');
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector('.newsletter__close-btn');
    this.hasSubscription = this.dataset.hasSubscription === 'true';
    this.delay = Number(this.dataset.delay) || 0;
    this.frequencyDays = Number(this.dataset.frequencyDays);
    this.maxShows = Number(this.dataset.maxShows);
    this.storageKey = this.dataset.storageKey || 'notificationPopupState';

    if (Number.isNaN(this.frequencyDays) || this.frequencyDays < 1) this.frequencyDays = 1;
    if (Number.isNaN(this.maxShows)) this.maxShows = 0;

    if (this.hasSubscription || !this.canShow()) return;

    setTimeout(() => {
      if (!this.canShow()) return;
      this.recordShow();
      this.popup.classList.remove('hidden');
      this.popup.classList.add('wt-popup-fade-in');
    }, this.delay * 1000);

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.hidePopup();
      });
    }
  }

  getPeriodMs() {
    return this.frequencyDays * 24 * 60 * 60 * 1000;
  }

  getState() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return { shows: [] };
      const parsed = JSON.parse(raw);
      const shows = Array.isArray(parsed.shows) ? parsed.shows.map(Number).filter(Boolean) : [];
      return { shows };
    } catch (error) {
      return { shows: [] };
    }
  }

  setState(state) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    } catch (error) {
      // Ignore storage write failures (private mode / quota).
    }
  }

  getRecentShows() {
    const now = Date.now();
    const periodStart = now - this.getPeriodMs();
    return this.getState().shows.filter((timestamp) => timestamp >= periodStart);
  }

  canShow() {
    if (this.maxShows <= 0) return true;
    return this.getRecentShows().length < this.maxShows;
  }

  recordShow() {
    const now = Date.now();
    const periodStart = now - this.getPeriodMs();
    const shows = this.getState()
      .shows.filter((timestamp) => timestamp >= periodStart)
      .concat(now);

    this.setState({ shows });
  }

  hidePopup() {
    this.popup.classList.add('hidden');
    this.popup.classList.remove('wt-popup-fade-in');
  }
}

customElements.define('notification-popup', NotificationPopup);
